import { KeywordDefinition } from 'ajv'
import dayjs from 'dayjs'

export const dateBeforeField: KeywordDefinition = {
  keyword: 'dateBeforeField',
  type: 'string',
  schemaType: 'string',
  errors: true,

  /**
   * validate(
   *   schema: string (the name of the other field),
   *   data: string (the value of this field),
   *   ctx: DataValidationCxt
   * )
   */
  validate(otherFieldName: string, data: string, schema: any, ctx: any): boolean {
    const parent = ctx.parentData

    // If parent not available, or other field missing, skip validation
    if (!parent || typeof parent !== 'object') return true

    const otherValue = parent[otherFieldName]
    if (typeof otherValue !== 'string') return true

    const d1 = dayjs(data, 'YYYY-MM-DD', true)
    const d2 = dayjs(otherValue, 'YYYY-MM-DD', true)

    if (!d1.isValid() || !d2.isValid()) return true

    const valid = d1.isBefore(d2)

    if (!valid) {
      ctx.errors = [
        {
          instancePath: ctx.instancePath,
          schemaPath: ctx.schemaPath,
          keyword: 'dateBeforeField',
          params: { otherFieldName, otherValue },
          message: `must be before ${otherFieldName} (${otherValue})`,
        },
      ]
    }

    return valid
  },
}
